import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMeta from 'vue-meta';

import moneyFilter from '@/filters/money';
import money2Filter from '@/filters/money2';
import money3WithCurrency from '@/filters/money3WithCurrency';
import money3WithCurrencyRange from '@/filters/money3WithCurrencyRange';
import money3Filter from '@/filters/money3';
import slugify from '@/filters/slugify';
import percentageFilter from '@/filters/percentage';

import App from './App.vue';
import router from './router';
import store from './store';

const options = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  timeout: 3000,
  position: 'top-right',
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: true,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  // Disable adding duplicate toasts
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter((t) => t.type === toast.type && t.content === toast.content).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  },
};

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCHi26CpkUrRo37rWHXAjvrQDtIGVjdbJU',
    libraries: 'places',
  },
});

Vue.use(Toast, options);
Vue.use(Vuelidate);
Vue.use(VueMeta);
Vue.filter('money', moneyFilter);
Vue.filter('money2', money2Filter);
Vue.filter('money3', money3Filter);
Vue.filter('money3WithCurrency', money3WithCurrency);
Vue.filter('money3WithCurrencyRange', money3WithCurrencyRange);
Vue.filter('slugify', slugify);
Vue.filter('percentage', percentageFilter);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
